import { render, staticRenderFns } from "./ShenPiTongJi.vue?vue&type=template&id=aeae0108&scoped=true&"
import script from "./ShenPiTongJi.vue?vue&type=script&lang=js&"
export * from "./ShenPiTongJi.vue?vue&type=script&lang=js&"
import style0 from "./ShenPiTongJi.vue?vue&type=style&index=0&id=aeae0108&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeae0108",
  null
  
)

export default component.exports